import { APIClient } from "../setup/axios/ApiHelper";

const api = new APIClient();

const MenuAPI = {
  getMenu: (params: any) => api.get('menu-access', params),
}

export default MenuAPI